
import { $ } from "../../third-party-imports";

export function attachLinkClickEvent(g2Data: any)
{
    $('.articleLink').on("click", function (e: any)
    {
        e.preventDefault();
        const articleIndex = e.target.getAttribute('data-index');
        const startingIndex = g2Data.response.start + parseInt(articleIndex as string);
        let index = startingIndex === 0 ? 0 : startingIndex - 1;
        localStorage.setItem('blog_article_prev_index', index.toString());
        window.location.href = e.target.getAttribute('href') ?? "";
    });
}
